import React, { useEffect, useState } from "react";
import Div from "../../components/common/Div";

export default function Footer() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <Div
      color={"#DFDFDF"}
      backgroundColor={"#00112e"}
      position={"static"}
      bottom={"0"}
      padding={"0 0 15px 0"}
      width={windowWidth >= 800 ? "50%" : "80%"}
      fontSize={"15px"}
    >
      By using the MobiTutorZA application you confirm that your personal
      information has been collected and is processed according to the POPI Act
      of 2013. See information document for further details.
    </Div>
  );
}
